import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKBruddtestResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import { Flex, Paper, Stack, Title, Box } from "@mantine/core";
const Bruddtest: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKBruddtestResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Bruddtest
        </Title>
        <Flex direction="column" mt="sm">
          <b>Måletiden er 60 sekunder &#40;s&#41;:</b>
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label="Fyll inn målt hastighet i venstre hanskeport (m/s):"
            value={data.inndata.maaleresultatVenstre}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.bruddtest.inndata.maaleresultatVenstre", Number(e.target.value))
            }
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex direction="column" mt="lg">
          <McInputNew
            label="Fyll inn målt hastighet i høyre hanskeport (m/s):"
            value={data.inndata.maaleresultatHoeyre}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData("testResultater.bruddtest.inndata.maaleresultatHoeyre", Number(e.target.value))
            }
            style={{ width: "25%" }}
          />
        </Flex>
        <Box mt="lg" style={{ width: "50%" }}>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) => onUpdateEditData("testResultater.bruddtest.inndata.kommentar", e.target.value)}
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default Bruddtest;
